module.exports = __webpack_public_path__ + "img/no_content3.48688852.png";